import { BaseFilterOption } from '../types';
import { VariantQuality } from '../../components';

export const config: BaseFilterOption = {
  id: 'omicsExplorer.filters.variantQuality',
  title: {
    id: 'omicsExplorer.filters.variantQuality',
    defaultMessage: 'Variant Quality',
  },
  content: VariantQuality,
};
